import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SidebarComponent from '../common/sidebar-component';
import ListedCompanyResultsContext from './context';
import SidebarContributorsComponentHeader from '../common/sidebar/sidebar-contributors-component-header';
import useGetContributorsByStockCodes from '../../../services/contributors/by-stock-codes-service';
import NanoProfile from '../common/nano-profile';

const ContributorsContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-top: 20px;
`;

export default function TopContributors({ stockCode }) {
  const { dispatch } = React.useContext(ListedCompanyResultsContext);
  const [{ data }, executeQuery] = useGetContributorsByStockCodes([stockCode.slug], 3);

  React.useEffect(() => {
    executeQuery();
  }, [executeQuery]);

  React.useEffect(() => {
    if (_.get(data, 'contributors.length')) {
      dispatch({ type: 'setContributors', payload: data.contributors });
    }
  }, [data, dispatch]);

  if (!_.get(data, 'contributors.length')) {
    return null;
  }

  return (
    <SidebarComponent>
      <SidebarContributorsComponentHeader
        query={stockCode.companyName}
      />
      <ContributorsContainer>
        {data.contributors.map(p => (
          <NanoProfile key={`contributor-${p.id}`} profile={p} dark small />
        ))}
      </ContributorsContainer>
    </SidebarComponent>
  );
}

TopContributors.propTypes = {
  stockCode: PropTypes.shape({
    stockExchange: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    companyName: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
};
